<template>
  <div class="cat-materia">
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} una materia</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todas.Nombre}} las materias</option>
        <option v-for="Materia in Materias" :value="Materia.MateriaId" :key="Materia.MateriaId">{{Materia.Nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        Materias: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object
    },
    mounted() {      
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;
  
      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_PJ_Catalogo_Establecer002Materia", parametros);
    },
    methods: {
      cargaCatalogoDeMaterias: function () {
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba

        axios.post(api.conexion + api.PJ.catalogos.C002Materias, this.parametros)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {              
              this.Materias = respuesta.data.Materias;

              if(this.parametros.elementosAOmitir != undefined){
                this.Materias = this.Materias.filter(element => {                   
                  if(!this.parametros.elementosAOmitir.includes(element.MateriaId))
                    return element;
                });
              }

              if(this.parametros.elementosAConservar != undefined && this.parametros.elementosAConservar != null  && this.parametros.elementosAConservar.length > 0){
                this.Materias = this.Materias.filter(element => {                  
                  if(this.parametros.elementosAConservar.includes(element.MateriaId))
                    return element;
                });
              }

              if(this.tipo.Id == enumeraciones.tiposDeSelect.Ninguno.Id && this.Materias.length >= 1 && (!this.valorDefinido || this.valorDefinido <= 0))
              {
                this.idDelModelo = this.Materias[0].MateriaId;
                this.elegirPrimerElemento(this.Materias[0].MateriaId);
              }
            }
          })
          .catch(excepcion => {
            console.log(exception);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
          })
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        
        this.$store.dispatch("A_PJ_Catalogo_Establecer002Materia", parametros);
        this.$emit("valorParaElPadre", evento);
        //evento.target[evento.target.selectedIndex].label esto sirve para obtener el label de valor actual
      },
      elegirPrimerElemento(id) {
        const parametros = {
          llave: this.idDelInput,
          valor: id
        }
        
        this.$store.dispatch("A_PJ_Catalogo_Establecer002Materia", parametros);
        //{id: id, nombre: this.PartidosJudiciales[id].Nombre}  lo que regresa el emit debe camrbiarse por esto si se busca obtener también el nombre 
        this.$emit("valorParaElPadrePrimerElemento", id);
      }
    },
    created() {
      this.cargaCatalogoDeMaterias();
    }
  }
</script>
<style>
.cat-materia .form-control {
  background-color: white !important;
  color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/components/PJ/Catalogos/002Materia.vue